import http from "../../http";
// 添加渠道
let add = data => {
  return http.post("marketcenter/urlChannel/save/channelTemplate", data);
};
// 删除渠道
let del = data => {
  return http.get("marketcenter/urlChannel/remove/channelTemplate", data);
};
// 渠道列表
let list = data => {
  return http.post("marketcenter/urlChannel/page/channelTemplate", data);
};
// 添加渠道分类
let addType = data => {
  return http.post("marketcenter/urlChannel/save/channeltype", data);
};
// 删除渠道分类
let delType = data => {
  return http.get("marketcenter/urlChannel/remove/channelType", data);
};
// 渠道分类列表
let typeList = params => {
  return http.get("marketcenter/urlChannel/page/channelType", params);
};

let urlChannel = data => {
  return http.get("marketcenter/urlChannel/get/urlChannel", data);
};
// 活动的渠道列表
let urlChannelList = data => {
  return http.post("marketcenter/urlChannel/page/channel", data);
};

// 渠道总数
let channelSum = data => {
  return http.post("marketcenter/urlChannel/page/channel_sum", data);
};

let addUrlChannel = data => {
  return http.post("marketcenter/urlChannel/add/channel", data);
};

let delUrlChannel = data => {
  return http.get("marketcenter/urlChannel/delete/channel", data);
};

let noneUrlChannelCount = data => {
  return http.get("marketcenter/urlChannel/get/not/urlcode/count", data);
};
// 渠道模板列表（非分页）
let listChannelTemplate = data => {
  return http.post("marketcenter/urlChannel/list/channelTemplate", data);
};
let getTree = data => {
  return http.get("activityservice/contactOrg/tree", data);
};

export default {
  add,
  del,
  list,
  addType,
  delType,
  typeList,
  addUrlChannel,
  delUrlChannel,
  urlChannelList,
  urlChannel,
  noneUrlChannelCount,
  listChannelTemplate,
  channelSum,
  getTree
};
